import { render, staticRenderFns } from "./ZnsTemplate.vue?vue&type=template&id=1882619d"
import script from "./ZnsTemplate.vue?vue&type=script&lang=js"
export * from "./ZnsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports